import { render, staticRenderFns } from "./pop-up-model.vue?vue&type=template&id=ecebbda6&"
import script from "./pop-up-model.vue?vue&type=script&lang=js&"
export * from "./pop-up-model.vue?vue&type=script&lang=js&"
import style0 from "./pop-up-model.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports